export const formText = {
  titleHeader: 'Ubah Jadwal',
  labelSubmissionType: '1. Pilih Tipe Pengajuan',
  swapScheduleText: 'Tukar Jadwal',
  changeHostText: 'Ganti Host',
  labelFindReschedule: '2. Cari Jadwal Pengganti',
  labelChangeHost: '2. Cari Host Pengganti',
  labelHostReplacement: 'Host Pengganti',
  placeholderHostReplacement: 'Pilih host pengganti',
  labelDate: 'Tanggal',
  placeholderDate: 'Pilih tanggal',
  labelSchedule: 'Jadwal Live',
  placeholderSchedule: 'Pilih Jadwal',
  labelHostName: 'Nama Host',
  placeholderHostName: 'Pilih Host',
  labelAccountLive: 'Account Live',
  descAutoInputSingleHost: 'Nama Host dan Account Live akan otomatis terisi setelah memilih Tanggal dan Jadwal Live Pengganti',
  descAutoInputMultiHost: 'Account Live akan otomatis terisi setelah memilih Tanggal dan Jadwal Live Pengganti',
  labelReason: '3. Alasan',
  placeholderReason: 'Masukkan alasan reschedule',
  labelAttachment: '4. Lampiran',
  captionAttachment: 'Upload screenshot atau bukti pendukung (maks 3 gambar)',
  attachmentTextTitle: 'Tap untuk upload file',
  attachmentTextDesc: 'Format PNG, JPG, JPEG  (maks 5 MB/gambar)',
  buttonCancelText: 'Batal',
  buttonSendText: 'Kirim',
  captionMaxChangeSchedule: '',
  captionNotAvailChangeSchedule: 'Kesempatan tukar jadwal habis. Coba lagi bulan depan.',
  noAvailableChangeScheduleText: 'Jadwal hari ini tidak bisa ditukar. Penukaran hanya bisa dilakukan maksimal H-1 sebelum jadwal dimulai.',
  getAlertQuotaText: (dataTotalRequest) => `Sisa ${dataTotalRequest?.remaining} dari ${dataTotalRequest?.maxRequest} kesempatan tukar jadwal bulan ini`,
};

export const cancelModalText = {
  title: 'Apakah kamu yakin ingin membatalkan pengajuan ini?',
  description: 'Setelah dibatalkan, kamu perlu mengajukan ulang jika ingin mengubah jadwal.',
  submitButton: 'Ya, batalkan',
  closeButton: 'Tutup',
};

export const sendModalText = {
  title: 'Apakah kamu yakin ingin mengirim pengajuan ini?',
  description: 'Pastikan semua data sudah benar sebelum dikirim. Pengajuan akan diproses oleh Operator.',
  submitButton: 'Ya, kirim',
  closeButton: 'Tutup',
  successText: 'Pengajuan ubah jadwal berhasil dikirim. Status akan diperbarui setelah diproses operator.',
  errorText: 'Terjadi kesalahan saat mengirim pengajuan tukar jadwal. Silakan coba lagi atau periksa koneksi kamu.',
};

export const scheduleRequestApprovalText = {
  pageTitle: 'Request Approval',
};

export const rescheduleTabText = {
  requestedText: 'Perlu Diproses',
  doneText: 'Selesai',
};

export const filterText = {
  searchPlaceholder: 'Cari...',
  brandPlaceholder: 'Pilih Brand',
  brandCounterLabel: 'Brand',
  typePlaceholder: 'Tipe Pengajuan',
  typeCounterLabel: 'Tipe',
  statusPlaceholder: 'Status',
  statusCounterLabel: 'Status',
  clearFilters: 'Clear Filters',
};

export const tableText = {
  emptyActionText: 'No data available',
  columns: {
    status: 'Status',
    requesterName: 'Nama Requester',
    brand: 'Brand',
    type: 'Tipe Pengajuan',
    replacementSchedule: 'Jadwal Pengganti',
    replacementHost: 'Host Pengganti',
    attachment: 'Lampiran',
    action: 'Action',
  },
  status: {
    approved: 'Disetujui',
    rejected: 'Ditolak',
    processing: 'Diproses',
  },
  actionButton: {
    detail: 'Detail',
  },
};

export const attachmentText = {
  alt: 'Attachment',
  noImages: 'No images',
};

export const actionModalText = {
  approve: {
    title: 'Konfirmasi Persetujuan',
    description: 'Apakah Anda yakin ingin menyetujui pengajuan ini?',
    confirmButton: 'Setujui',
    cancelButton: 'Batal',
  },
  reject: {
    title: 'Konfirmasi Penolakan',
    description: 'Apakah Anda yakin ingin menolak pengajuan ini?',
    confirmButton: 'Tolak',
    cancelButton: 'Batal',
  },
  loading: {
    title: 'Harap tunggu',
    approveDescription: 'Sedang memproses persetujuan...',
    rejectDescription: 'Sedang memproses penolakan...',
  },
  success: {
    approveDescription: 'Pengajuan berhasil disetujui',
    rejectDescription: 'Pengajuan berhasil ditolak',
  },
  error: {
    title: 'Terjadi kesalahan',
    approveDescription: 'Gagal menyetujui pengajuan. Silakan coba lagi.',
    rejectDescription: 'Gagal menolak pengajuan. Silakan coba lagi.',
  },
};
